import React, { useState, useEffect } from "react";
import 'select2/dist/css/select2.min.css';
import 'select2';
import { Link, useNavigate } from "react-router-dom";
import { oneKlicks } from "../../../../SDK/oneclick";
import { debugLog } from "../../../../utils/debug";
import he from 'he';
import LocationSearch from "../../SerchDocters/Components/LocationSearch";

const Searching = () => {
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState("");
    const [location, setLocation] = useState("");
    const [specialities, setSpecialities] = useState([]);
    const [services, setServices] = useState([]);
    const [selectedSpeciality, setSelectedSpeciality] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [advancedSearchVisible, setAdvancedSearchVisible] = useState(false);
    const [error, setError] = useState(null);
    const [coordinates, setCoordinates] = useState({ lat: 17.307197, lng: 78.584616 });
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        fetchSpecialities();
        fetchServices();
    }, []);

    useEffect(() => {
        if (selectedSpeciality) {
            fetchServices();
        }
    }, [selectedSpeciality]);

    const fetchSpecialities = async () => {
        try {
            const getSpecialities = await oneKlicks.read("", "specialities", {}, "id ASC", "", "", "");
            if (getSpecialities.success && getSpecialities.data) {
                setSpecialities(getSpecialities.data);
            } else {
                throw new Error("Failed to load specialities");
            }
        } catch (error) {
            setError("Failed to load specialities. Please try again.");
        }
    };

    const fetchServices = async () => {
        try {
            const getServices = await oneKlicks.read("", "services", {}, "id ASC", "", "", "");
            if (getServices.success && getServices.data) {
                setServices(getServices.data);
            } else {
                throw new Error("Failed to load services");
            }
        } catch (error) {
            setError("Failed to load services. Please try again.");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Construct the search URL with parameters
        const searchParams = new URLSearchParams({
            search: keyword,
            lat: coordinates.lat,
            lng: coordinates.lng,
            page: 1,
            speciality: selectedSpeciality || '',
            service: selectedService || '',
            location: location
        });

        // Redirect to search-doctors page with parameters
        console.log("searchParams", `/search-doctors?${searchParams.toString()}`);
        navigate(`/search-doctors?${searchParams.toString()}`);
    };

    const toggleAdvancedSearch = () => {
        setAdvancedSearchVisible(!advancedSearchVisible);
    };

    const handleLocationChange = (newLocation, newCoordinates) => {
        setLocation(newLocation);
        if (newCoordinates) {
            setCoordinates(newCoordinates);
        }
    };

    const handleOptionSelect = (selectedOption) => {
        setSelectedSpeciality(selectedOption?.value || null);
    };

    const handleKeywordChange = async (e) => {
        const searchTerm = e.target.value;
        setKeyword(searchTerm);
        setShowResults(true);

        if (searchTerm.length >= 2) {
            setSearchLoading(true);
            try {
                const results = await oneKlicks.search("", "doctors", { search: searchTerm });
                if (results.success && results.data) {
                    setSearchResults(results.data);
                } else {
                    setSearchResults([]);
                }
            } catch (error) {
                setSearchResults([]);
            } finally {
                setSearchLoading(false);
            }
        } else {
            setSearchResults([]);
        }
    };

    const handleResultSelect = (result) => {
        setKeyword(result.display_name || result.name);
        setShowResults(false);
        // Optionally, set selectedSpeciality or selectedService based on the result
        // For now, we'll just clear them if a doctor/clinic/hospital is selected
        setSelectedSpeciality(null);
        setSelectedService(null);
    };

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-4d916c7 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="4d916c7" data-element_type="section">
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1f8daed" data-id="1f8daed" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-2c02a01 elementor-widget elementor-widget-dc_element_search_form" data-id="2c02a01" data-element_type="widget" data-widget_type="dc_element_search_form.default">
                            <div className="elementor-widget-container">
                                <div className="dc-haslayout dc-section-214065">
                                    <div className="dc-searchform-holder">
                                        <div className="dc-advancedsearch home">
                                            <div className="dc-title">
                                                <h2>Start Your Search</h2>
                                            </div>
                                            <form className="dc-formtheme dc-form-advancedsearch" onSubmit={handleSubmit}>
                                                <fieldset className="home-search-form row">
                                                    <div className="form-group col-lg-4 col-sm-4 col-md-4 col-xl-4 serch-bar-left">
                                                        <LocationSearch
                                                            location={location}
                                                            setLocation={handleLocationChange}
                                                        />
                                                    </div>
                                                    <div className="form-group col-lg-8 col-sm-8 col-md-8 col-xl-8 serch-bar-right" style={{ position: 'relative' }}>
                                                        <input type="hidden" name="searchby" className="form-control" value="both" />
                                                        <input
                                                            type="text"
                                                            name="keyword"
                                                            className="form-control"
                                                            placeholder="Search doctors, clinics, hospitals, etc."
                                                            value={keyword}
                                                            onChange={handleKeywordChange}
                                                            onFocus={() => {
                                                                if (searchResults.length > 0) {
                                                                    setShowResults(true);
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                setTimeout(() => setShowResults(false), 200);
                                                            }}
                                                        />

                                                        {/* Search Results Dropdown */}
                                                        {showResults && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: '100%',
                                                                left: 0,
                                                                right: 0,
                                                                backgroundColor: 'white',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '4px',
                                                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                                                zIndex: 1000,
                                                                maxHeight: '300px',
                                                                overflowY: 'auto'
                                                            }}>
                                                                {searchLoading ? (
                                                                    <div style={{ padding: '15px', textAlign: 'center', color: '#666' }}>
                                                                        Searching...
                                                                    </div>
                                                                ) : searchResults.length > 0 ? (
                                                                    searchResults.map((result, index) => (
                                                                        <div
                                                                            key={result.id || index}
                                                                            onClick={() => handleResultSelect(result)}
                                                                            style={{
                                                                                padding: '12px 15px',
                                                                                borderBottom: '1px solid #eee',
                                                                                cursor: 'pointer',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '10px'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.target.style.backgroundColor = '#f5f5f5';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.target.style.backgroundColor = 'white';
                                                                            }}
                                                                        >
                                                                            <div style={{
                                                                                width: '40px',
                                                                                height: '40px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#1890ff',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                color: 'white',
                                                                                fontSize: '16px',
                                                                                fontWeight: 'bold'
                                                                            }}>
                                                                                {(result.display_name || result.name || 'D').charAt(0).toUpperCase()}
                                                                            </div>
                                                                            <div>
                                                                                <div style={{ fontWeight: 'bold', color: '#333' }}>
                                                                                    {result.display_name || result.name}
                                                                                </div>
                                                                                {result.speciality_id && (
                                                                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                                                                        {result.speciality_id}
                                                                                    </div>
                                                                                )}
                                                                                {result.country && (
                                                                                    <div style={{ fontSize: '12px', color: '#999' }}>
                                                                                        {result.country}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : keyword.trim().length >= 2 ? (
                                                                    <div style={{ padding: '15px', textAlign: 'center', color: '#666' }}>
                                                                        No results found for "{keyword}"
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        )}

                                                        {/* Error Message */}
                                                        {error && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                top: '100%',
                                                                left: 0,
                                                                right: 0,
                                                                backgroundColor: '#fff2f0',
                                                                border: '1px solid #ffccc7',
                                                                borderRadius: '4px',
                                                                padding: '8px 12px',
                                                                color: '#ff4d4f',
                                                                fontSize: '12px',
                                                                zIndex: 1001
                                                            }}>
                                                                {error}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="dc-formbtn">
                                                        <button type="submit" className="dc-serach-form h-40">
                                                            <i className="ti-search"></i><span>&nbsp;Search now</span>
                                                        </button>
                                                    </div>
                                                </fieldset>

                                                {advancedSearchVisible && (
                                                    <fieldset className="advancefilters-wrap home-search-form row" style={{ display: 'block' }}>
                                                        <div className="form-group col-lg-6 col-sm-6 col-md-6 col-xl-6">
                                                            <div className="dc-select">
                                                                <select
                                                                    name="specialities"
                                                                    className="custom-chosen-select custom-select2"
                                                                    value={selectedSpeciality || ""}
                                                                    onChange={(e) => handleOptionSelect({ value: e.target.value })}
                                                                >
                                                                    <option value="">Select a speciality</option>
                                                                    {specialities.map((speciality) => (
                                                                        <option key={speciality.id} value={speciality.id} style={{ width: '200px' }}>
                                                                            {he.decode(speciality.name)}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-lg-6 col-sm-6 col-md-6 col-xl-6">
                                                            <div className="dc-select" id="search_services">
                                                                <select
                                                                    name="services"
                                                                    className="custom-chosen-select custom-select2"
                                                                    value={selectedService || ""}
                                                                    onChange={(e) => setSelectedService(e.target.value)}
                                                                >
                                                                    <option value="">Select a service</option>
                                                                    {services
                                                                        .filter(
                                                                            (service) =>
                                                                                !selectedSpeciality || service.speciality_id === selectedSpeciality
                                                                        )
                                                                        .map((service) => (
                                                                            <option
                                                                                key={service.id}
                                                                                value={service.id}
                                                                                style={{ whiteSpace: "nowrap" }} // 👈 prevent text wrapping
                                                                            >
                                                                                {he.decode(service.name)}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                    </fieldset>
                                                )}
                                            </form>
                                            <div className="dc-advancesearch-holder">
                                                <button
                                                    type="button"
                                                    className="dc-docsearch dc-serach-toggle"
                                                    onClick={toggleAdvancedSearch}
                                                >
                                                    <span className="dc-advanceicon serch-bar-advanced-search"><i></i> <i></i> <i></i></span>
                                                    <span>Advanced Search</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="dc-jointeamholder">
                                            <div className="dc-jointeam">
                                                <figure className="dc-jointeamimg">
                                                    <img decoding="async" src="//css.meddylist.com//wp-content/uploads/2019/08/img-04-1.png" alt="img description" />
                                                </figure>
                                                <div className="dc-jointeamcontent">
                                                    <h3><span>Are You A Doctor?</span> Join Our Team</h3>
                                                    <Link to="/authentication" className="dc-btn dc-btnactive">Join As Doctors</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#3d4461',
        minHeight: '44px',
        maxHeight: '44px',
        borderColor: state.isFocused ? '#4e5779' : '#4e5779',
        boxShadow: state.isFocused ? '0 0 0 1px #4e5779' : 'none',
        '&:hover': {
            borderColor: '#4e5779',
        },
        cursor: 'pointer',
    }),
    input: (provided) => ({
        ...provided,
        color: '#fff',
        margin: '0',
        padding: '0',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#fff',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#fff',
        margin: '0',
        padding: '0',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        backgroundColor: '#3d4461',
        marginTop: '4px',
        position: 'absolute',
        width: '100%',
    }),
    menuList: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#4e5779' : '#3d4461',
        color: '#fff',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#4e5779',
        },
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
    }),
};

export default Searching; 
